export const TERMS_VERSION = '2026-01-12';
export const HUMAN_REVIEW_VERSION = '2026-01-12';
